export enum SHAPES {
  CHOPPED = 'chopped',
  PENTAGON = 'pentagon',
  HEXAGON = 'hexagon'
}
